
import * as React from 'react';

export const InProgress = ({
  className,
  size = '24px',
  color = 'currentColor' }) => /*#__PURE__*/

React.createElement("svg", {

  className: className,
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg" }, /*#__PURE__*/

React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
  fill: color }), /*#__PURE__*/

React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.21928 13.126C9.43343 13.6549 9.79396 14.1117 10.2586 14.4429C10.7232 14.7741 11.2726 14.9659 11.8424 14.9959C12.4122 15.0258 12.9787 14.8927 13.4755 14.6121C13.9723 14.3314 14.3787 13.9149 14.6472 13.4115C14.9156 12.908 15.0349 12.3384 14.9911 11.7695C14.9472 11.2006 14.7421 10.656 14.3997 10.1996C14.0573 9.74324 13.5918 9.39394 13.0579 9.19273C12.524 8.99152 11.9437 8.94674 11.3853 9.06364L10.9755 7.10607C11.9063 6.91123 12.8733 6.98587 13.7632 7.32122C14.653 7.65657 15.4288 8.23873 15.9995 8.9994C16.5702 9.76008 16.9121 10.6677 16.9852 11.6159C17.0582 12.564 16.8594 13.5133 16.412 14.3524C15.9646 15.1916 15.2871 15.8857 14.4592 16.3534C13.6312 16.8211 12.687 17.043 11.7374 16.9931C10.7877 16.9432 9.87201 16.6234 9.09766 16.0715C8.32331 15.5195 7.72243 14.7581 7.3655 13.8767L9.21928 13.126Z",
  fill: color }));